import React from "react";
import "./App.css";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import About from "./components/About";
import Capabilities from "./components/Capabilities";
import Services from "./components/Services";
import GrowWithUs from "./components/GrowWithUs";
import Collaboration from "./components/Collaboration";
import Contact from "./components/Contact";
import Footer from "./components/Footer";

function App() {
  return (
    <div className="App">
      <Navigation />
      <main>
        <Hero />
        <About />
        <Capabilities />
        <Services />
        <GrowWithUs />
        <Collaboration />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

export default App;